import { imageUrl } from "@/util/api/baseUrl";
import { ConvertLink } from "@/util/tools";
import Image from "next/image";
import Link from "next/link";


interface EssenceGroupProps {
    title: string;
    essences: {
        essence_url: string;
        essence_image: string;
        essence_image_alt: string;
        essence_title: string;
    }[];
}

interface EssenceType {
    id: number;
    essence_title: string;
    essence_second_title: string;
    essence_url: string;
    essence_image: string;
    essence_image_alt: string;
    Products: Product[];
    product_essence_group: number;
}

interface Product {
    id: number;
    ProductEssence: ProductEssence;
}

interface ProductEssence {
    product_essence_group: number;
}

const EssenceGroup = ({ title, essences }: EssenceGroupProps) => (
    <div className="my-1 flex justify-between">
        {essences.length ? (
            <p className="p-2 text-nowrap text-sm font-normal text-center">
                {title}:{" "}
            </p>
        ) : null}
        <div className="flex flex-wrap justify-center sm:justify-between px-2">
            {essences.map((es, index) => (
                <div key={index} className="m-1">
                    <Link
                        href={`/essence/${ConvertLink(es.essence_url)}`}
                        className="m-auto text-center justify-between flex flex-wrap items-center"
                    >
                        <div className="rounded-[50%] relative sm:h-[56px] h-10 w-10 sm:w-[56px]">
                            <Image
                                fill
                                alt={es.essence_image_alt || es.essence_title}
                                src={imageUrl + es.essence_image}
                                loading="lazy"  // تغییر حالت لودینگ به lazy
                                quality={85}  // تنظیم کیفیت بهینه
                                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw" // تعریف سایزهای مختلف برای دستگاه‌ها
                                className="rounded-[50%] "
                                style={{
                                    filter: 'brightness(1) contrast(1.1) saturate(1.1)',
                                }}
                            />
                        </div>
                        <p className="text-[12px] font-normal border-ebony mr-1">
                            {es.essence_title}
                        </p>
                    </Link>
                </div>
            ))}
        </div>
    </div>
);

const EssenceGroupList = ({ title, essences }: EssenceGroupProps) => (
    <div className="my-1 flex items-start justify-start">
        {essences.length ? (
            <p className="p-2 text-nowrap text-text text-base font-bold text-center">
                {title} : 
            </p>
        ) : null}
        <div className="flex flex-wrap justify-start px-2">
            {essences.map((es, index) => (
                <Link
                    href={`/essence/${ConvertLink(es.essence_url)}`} key={index} className="m-1 text-center">
                    <div
                        className="m-auto inline-flex flex-col border-2 p-1 border-pink rounded-[50%]"
                    >
                        <div className="rounded-[50%] relative sm:h-[56px] h-8 w-8 sm:w-[56px]">
                            <Image
                                fill
                                alt={es.essence_image_alt || es.essence_title}
                                src={imageUrl + es.essence_image}
                                loading="lazy"  // تغییر حالت لودینگ به lazy
                                quality={85}  // تنظیم کیفیت بهینه
                                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw" // تعریف سایزهای مختلف برای دستگاه‌ها
                                className="rounded-[50%] "
                                style={{
                                    filter: 'brightness(1) contrast(1.1) saturate(1.1)',
                                }}
                            />
                        </div>
                    </div>
                    <p className="sm:text-[14px] text-[12px] font-normal text-text">
                        {es.essence_title}
                    </p>
                </Link>
            ))}
        </div>
    </div>
);

const EssencesGroup = ({ style, essence }: { style: boolean, essence: any }) => {
    if (style) {
        return (
            <div>
                <EssenceGroupList title="نت اول" essences={essence[1]} />
                <EssenceGroupList title="نت دوم" essences={essence[2]} />
                <EssenceGroupList title="نت سوم" essences={essence[3]} />
                <EssenceGroupList title="نت های شناخته شده" essences={essence[4]} />
            </div>
        );
    }
    return (
        <div>
            <EssenceGroup title="نت اول" essences={essence[1]} />
            <EssenceGroup title="نت دوم" essences={essence[2]} />
            <EssenceGroup title="نت سوم" essences={essence[3]} />
            <EssenceGroup title="نت های شناخته شده" essences={essence[4]} />
        </div>
    );
}

export default EssencesGroup